module.exports = __webpack_public_path__ + "img/microscoop.ee8f1282.jpg";